import React from 'react';

const AboutSection = ({ t, timerDateString }: any) => (
  <section className="about-drimrun-section" id="about">
    <h2>{t.aboutDrimRunTitle}</h2>
    {Array.isArray(t.aboutDrimRunDesc)
      ? t.aboutDrimRunDesc.map((p: string, i: number) => (
          <p className="about-drimrun-desc" key={i}>{p}</p>
        ))
      : <p className="about-drimrun-desc">{t.aboutDrimRunDesc}</p>}
    <div className="about-drimrun-date-place">
      <span className="about-drimrun-date">{timerDateString}</span>
      <span className="about-drimrun-place">{t.CityName}</span>
    </div>
  </section>
);

export default AboutSection;
